import { Link, NavLink } from 'react-router-dom'

import { Icon, IconName } from 'components/Icon'
import { tx } from 'lib/i18n'

import { NavBadge } from '../atoms/NavBadge'
import { useRegion } from '../context/RegionContext'

interface SidebarNavItemProps {
  icon: IconName
  label: string
  to?: string
  /** Supplies the active state manually instead of letting NavLink match the route. */
  active?: boolean
  end?: boolean
  disabled?: boolean
  disabledHint?: string
  soon?: boolean
  count?: number
}

const Content = ({ icon, label, soon, soonLabel, count }: Pick<SidebarNavItemProps, 'icon' | 'label' | 'soon' | 'count'> & { soonLabel: string }) => (
  <>
    <Icon name={icon} />
    <span className="shell__nav-label">{label}</span>
    {soon ? <NavBadge>{soonLabel}</NavBadge> : null}
    {count ? <span className="shell__nav-count">{count > 99 ? '99+' : count}</span> : null}
  </>
)

export const SidebarNavItem = ({ icon, label, to, active, end, disabled, disabledHint, soon, count }: SidebarNavItemProps) => {
  const { locale } = useRegion()
  const soonLabel = tx(locale, 'قريباً', 'Soon')

  if (disabled || !to) {
    return (
      <span className="shell__nav-item is-disabled" aria-disabled="true" title={disabledHint ?? (soon ? soonLabel : undefined)}>
        <Content icon={icon} label={label} soon={soon} soonLabel={soonLabel} />
      </span>
    )
  }

  if (active !== undefined) {
    return (
      <Link to={to} className={active ? 'shell__nav-item is-active' : 'shell__nav-item'}>
        <Content icon={icon} label={label} soonLabel={soonLabel} count={count} />
      </Link>
    )
  }

  return (
    <NavLink to={to} end={end} className={({ isActive }) => (isActive ? 'shell__nav-item is-active' : 'shell__nav-item')}>
      <Content icon={icon} label={label} soonLabel={soonLabel} count={count} />
    </NavLink>
  )
}
